export const IS_PRODUCTION = process.env.REACT_APP_CHAIN_TYPE === 'production';

export const CHAIN_TYPE = IS_PRODUCTION ? 'mainnet' : 'testnet';
